const emailKey = (value) => String(value || "").trim().toLowerCase();

export const resolveMonthlyFeePayer = (rate, rates = []) => {
  const adviserEmail = String(rate?.adviserEmail || "").trim();
  const paidBy = String(rate?.paidBy || "").trim();
  const payerEmail = paidBy || adviserEmail;
  const payer = rates.find((candidate) =>
    emailKey(candidate?.adviserEmail) === emailKey(payerEmail),
  );
  const paidByAnotherAdviser = Boolean(
    paidBy && emailKey(paidBy) !== emailKey(adviserEmail),
  );

  return {
    adviser: payer?.adviser || rate?.adviser || payerEmail,
    adviserEmail: payer?.adviserEmail || payerEmail,
    practice: payer?.practice || payer?.brandName || rate?.practice || rate?.brandName || "",
    chargedForAdviser: rate?.adviser || adviserEmail,
    chargedForAdviserEmail: adviserEmail,
    paidByAnotherAdviser,
  };
};
